const INVALID_FILENAME_CHARS = /[\\:*?"<>|]/g;
export function sanitizeFilename(value) {
    return value.replace(INVALID_FILENAME_CHARS, '').trim();
}
export function formatAccrualPeriod(competenceDate) {
    const match = /^(\d{4})-(\d{2})/.exec(competenceDate?.trim() ?? '');
    if (!match) {
        return '';
    }
    const [, year, month] = match;
    return `${month}/${year}`;
}
export function resolveOrderIdentifier(identification, fallback) {
    const trimmed = identification?.trim();
    if (trimmed) {
        return trimmed;
    }
    return fallback;
}
export function buildContractFilename(razaoSocial) {
    return `Contrato Domínio Benefícios - ${sanitizeFilename(razaoSocial)}`;
}
export function buildBoletoFilename(razaoSocial, competencia, idPedido) {
    return `Boleto Domínio Benefícios - ${sanitizeFilename(razaoSocial)} - ${sanitizeFilename(competencia)} - ${sanitizeFilename(idPedido)}`;
}
export function buildRechargeReportFilename(razaoSocial, competencia, idPedido) {
    return `Detalhes da Recarga Domínio Benefícios - ${sanitizeFilename(razaoSocial)} - ${sanitizeFilename(competencia)} - ${sanitizeFilename(idPedido)}`;
}
export function buildPaymentReceiptFilename(razaoSocial, competencia, idPedido) {
    return `Comprovante de Pagamento Domínio Benefícios - ${sanitizeFilename(razaoSocial)} - ${sanitizeFilename(competencia)} - ${sanitizeFilename(idPedido)}`;
}
export function buildTaxInvoiceFilename(razaoSocial, competencia, idPedido) {
    return `Nota Fiscal Domínio Benefícios - ${sanitizeFilename(razaoSocial)} - ${sanitizeFilename(competencia)} - ${sanitizeFilename(idPedido)}`;
}
function toFilenameDate(isoDate) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate.trim());
    if (!match) {
        return '';
    }
    const [, year, month, day] = match;
    return `${day}-${month}-${year}`;
}
function buildRechargeReportPeriodFilename(modality, razaoSocial, startDate, endDate) {
    const periodo = `${toFilenameDate(startDate)}_${toFilenameDate(endDate)}`;
    const razao = sanitizeFilename(razaoSocial).replaceAll('/', '');
    return `Relatorio ${modality} Dominio Beneficios - ${razao} - ${periodo}`;
}
export function buildCpfRechargeReportFilename(razaoSocial, startDate, endDate) {
    return buildRechargeReportPeriodFilename('por CPF', razaoSocial, startDate, endDate);
}
export function buildOrderRechargeReportFilename(razaoSocial, startDate, endDate) {
    return buildRechargeReportPeriodFilename('por pedido', razaoSocial, startDate, endDate);
}
